<template>
  <p class="alert-dialog-description">
    <slot />
  </p>
</template>

<script setup lang="ts">
// Add your component logic here
</script>

<style scoped>
.alert-dialog-description {
  /* Add your styles here */
}
</style>
